import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import OperatorTypes from '../../../common/redux/actions/types/OperatorTypes';
import PostalOperatorUnlocodeSelector from '../../../wizard/target-node-unlocode-selector/components/PostalOperatorUnlocodeSelector';
import {
  getArrivalCheckedUnlocodes,
  getArrivalPostalOperators,
  getDepartureCheckedUnlocodes,
  getDeparturePostalOperators,
  getExpandedArrivalPostalOperators,
  getExpandedDeparturePostalOperatorsUnlocodeAdmin,
  getSelectedArrivalPostalOperators,
  getSelectedDeparturePostalOperators,
} from '../../../wizard/target-node-unlocode-selector/redux/selectors/PostalOperatorSelectors';
import {
  retrieveOutboundPostalOperatorsUnlocodeRequestActionCreator,
  departureUnlocodeCheckedActionCreator,
  onDeparturePostalOperatorExpandedUnlocodeAdmin,
  onDeSelectAllDepartureUnlocodes,
  onSelectAllDepartureUnlocodes,
} from '../../../wizard/target-node-unlocode-selector/redux/actions/DeparturePostalOperatorActions';
import {
  retrieveInboundPostalOperatorsUnlocodeRequestActionCreator,
  arrivalUnlocodeCheckedActionCreator,
  onArrivalPostalOperatorExpanded,
  onSelectAllArrivalUnlocodes,
  onDeSelectAllArrivalUnlocodes,
} from '../../../wizard/target-node-unlocode-selector/redux/actions/ArrivalPostalOperatorActions';
import {
  saveGlobalSelectionUnlocodeRequestActionCreator,
  setTabButtonStatus,
} from '../redux/actions/AdminDashboardActions';
import AdminPresetLocationSidebarContainer from './AdminPresetLocationSidebarContainer';
import { createPresetSelectionsOnSave } from '../../../react-table/helpers/utils';
import SaveUnlocodeSelectionModal
  from '../../../wizard/target-node-unlocode-selector/components/SaveUnlocodeSelectionModal';

export class GlobalPresetsLocationContainer extends Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
    this.state = {
      showOnlySelectedDeparturePostalOperators: false,
      showOnlySelectedArrivalPostalOperators: false,
      showSaveSelectionModal: false,
      saveSelectionCheckedUnlocodes: [],
      saveSelectionSelections: [],
      postalOperatorType: '',
    };
  }

  componentDidMount() {
    const defaultDate = moment();
    this.props.retrieveOutboundPostalOperatorsUnlocodeRequestActionCreator(
      {
        defaultDirection: 'I',
        startDate: defaultDate,
        endDate: defaultDate,
      },
      'Admin',
      '',
    );

    this.props.retrieveInboundPostalOperatorsUnlocodeRequestActionCreator(
      {
        defaultDirection: 'I',
        startDate: defaultDate,
        endDate: defaultDate,
      },
      'Admin',
      '',
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.departureCheckedUnlocodes !== prevProps.departureCheckedUnlocodes && this.props.departureCheckedUnlocodes.length !== 0) {
      this.props.setTabButtonStatus(true);
    }
    if (this.props.departureCheckedUnlocodes.length === 0 && prevProps.departureCheckedUnlocodes.length !== 0) {
      this.setState({
        showOnlySelectedDeparturePostalOperators: false,
      });
    }
  }

  onSelectAllDeparturePostalOperators = () => {
    this.props.onSelectAllDepartureUnlocodes(this.props.departurePostalOperatorsNodes);
  };

  onSelectAllArrivalPostalOperators = () => {
    this.props.onSelectAllArrivalUnlocodes(this.props.arrivalPostalOperatorsNodes);
  };

  onDeSelectAllDeparturePostalOperators = () => {
    this.setState({
      showOnlySelectedDeparturePostalOperators: false,
    });
    this.props.onDeSelectAllDepartureUnlocodes();
  };

  onDeSelectAllArrivalPostalOperators = () => {
    this.setState({
      showOnlySelectedArrivalPostalOperators: false,
    });
    this.props.onDeSelectAllArrivalUnlocodes();
  };

  onSelectDeparturePostalOperatorOrUnlocode = (selected) => {
    if (selected.length === 0) {
      this.setState({
        showOnlySelectedDeparturePostalOperators: false,
      });
    }
    // eslint-disable-next-line react/prop-types
    this.props.departureUnlocodeCheckedActionCreator(selected, this.props.report);
  };

  onSelectArrivalPostalOperatorOrUnlocode = (selected) => {
    if (selected.length === 0) {
      this.props.updateUI('showOnlySelectedArrivalPostalOperators', false);
    }
    this.props.arrivalUnlocodeCheckedActionCreator(selected, this.props.report);
  };

  onExpandDeparturePostalOperator = (expanded) => {
    this.props.onDeparturePostalOperatorExpandedUnlocodeAdmin(expanded);
  };

  onExpandArrivalPostalOperator = (expanded) => {
    this.props.onArrivalPostalOperatorExpanded(expanded);
  };

  onToggleShowOnlySelectedDeparturePostalOperators = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showOnlySelectedDeparturePostalOperators: !this.state.showOnlySelectedDeparturePostalOperators,
    });
  };

  onToggleShowOnlySelectedArrivalPostalOperators = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showOnlySelectedArrivalPostalOperators: !this.state.showOnlySelectedArrivalPostalOperators,
    });
  };

  openSaveSelectionModalForDeparture = () => {
    this.openSaveSelectionModal({
      checkedUnlocodes: createPresetSelectionsOnSave(this.props.departureCheckedUnlocodes, this.props.departurePostalOperatorsNodes),
      selections: this.props.departureSelections,
      postalOperatorType: 'DEPARTURE',
    });
  };

  openSaveSelectionModalForArrival = () => {
    this.openSaveSelectionModal({
      checkedUnlocodes: createPresetSelectionsOnSave(this.props.arrivalCheckedUnlocodes, this.props.arrivalPostalOperatorsNodes),
      selections: this.props.arrivalSelections,
      postalOperatorType: 'ARRIVAL',
    });
  };

  openSaveSelectionModal = ({ checkedUnlocodes, selections, postalOperatorType }) => {
    this.setState({
      showSaveSelectionModal: true,
      saveSelectionCheckedUnlocodes: checkedUnlocodes,
      saveSelectionSelections: selections,
      postalOperatorType,
    });
  };

  closeSaveSelectionModal = () => {
    this.setState({
      showSaveSelectionModal: false,
    });
  };

  saveSelection = ({ name, checkedUnlocodes }) => {
    this.props.saveGlobalSelectionUnlocodeRequestActionCreator(
      name,
      'I',
      this.state.postalOperatorType,
      checkedUnlocodes,
    );
    this.closeSaveSelectionModal();
  };

  render() {
    console.log(this.props.departurePostalOperatorsNodes, this.props.departureExpandedPostalOperators);
    const departurePostalOperatorSelectorProps = {
      selected: this.props.departureCheckedUnlocodes,
      expanded: this.props.departurePostalOperatorsNodes === [] ? [] : this.props.departureExpandedPostalOperators,
      // eslint-disable-next-line no-unneeded-ternary
      expandDisabled: this.props.departurePostalOperatorsNodes === [] ? true : false,
      isShowOnlySelected: this.state.showOnlySelectedDeparturePostalOperators,
      postalOperatorNodes: this.state.showOnlySelectedDeparturePostalOperators ?
        this.props.selectedDeparturePostalOperatorsNodes : this.props.departurePostalOperatorsNodes,
      originalPostalOperatorNodes: this.props.departurePostalOperatorsNodes,
      onSelect: this.onSelectDeparturePostalOperatorOrUnlocode,
      onExpand: this.onExpandDeparturePostalOperator,
      onSelectAll: this.onSelectAllDeparturePostalOperators,
      onDeSelectAll: this.onDeSelectAllDeparturePostalOperators,
      onShowOnlySelected: this.onToggleShowOnlySelectedDeparturePostalOperators,
      openSaveSelectionModal: this.openSaveSelectionModalForDeparture,
      saveSelectionButtonHidden: true,
    };
    // eslint-disable-next-line no-unused-vars
    const arrivalPostalOperatorSelectorProps = {
      selected: this.props.arrivalCheckedUnlocodes,
      expanded: this.props.arrivalExpandedPostalOperators,
      expandDisabled: false,
      isShowOnlySelected: this.state.showOnlySelectedArrivalPostalOperators,
      postalOperatorNodes: this.state.showOnlySelectedArrivalPostalOperators ?
        this.props.selectedArrivalPostalOperatorsNodes : this.props.arrivalPostalOperatorsNodes,
      originalPostalOperatorNodes: this.props.arrivalPostalOperatorsNodes,
      onSelect: this.onSelectArrivalPostalOperatorOrUnlocode,
      onExpand: this.onExpandArrivalPostalOperator,
      onSelectAll: this.onSelectAllArrivalPostalOperators,
      onDeSelectAll: this.onDeSelectAllArrivalPostalOperators,
      onShowOnlySelected: this.onToggleShowOnlySelectedArrivalPostalOperators,
      openSaveSelectionModal: this.openSaveSelectionModalForArrival,
      saveSelectionButtonHidden: true,
    };
    return (
      <div>
        <div className="operator-selector-wrapper">
          {this.state.showSaveSelectionModal &&
          <SaveUnlocodeSelectionModal
            saveSelection={this.saveSelection}
            closeModal={this.closeSaveSelectionModal}
            checkedUnlocodes={this.state.saveSelectionCheckedUnlocodes}
            selections={this.state.saveSelectionSelections}
          />
          }
          <div className="operator-sidebar">
            <AdminPresetLocationSidebarContainer
              operatorType={OperatorTypes.DEPARTURE}
              operators={this.props.departurePostalOperatorsNodes}
              checked={this.props.departureCheckedUnlocodes}
            />
          </div>
          <div className="operators">
            <div className="operators-selection-panel">
              <div className="operator">
                <PostalOperatorUnlocodeSelector
                  title="LOCATION"
                  {...departurePostalOperatorSelectorProps}
                />
              </div>

              {/* <div className="operator">
                <PostalOperatorUnlocodeSelector
                  title="ARRIVAL"
                  {...arrivalPostalOperatorSelectorProps}
                />
              </div> */}
            </div>
          </div>
          {/* <div className="operator-sidebar">
            <AdminPresetLocationSidebarContainer
              operatorType={OperatorTypes.ARRIVAL}
              operators={this.props.arrivalPostalOperatorsNodes}
              checked={this.props.arrivalCheckedUnlocodes}
            />
          </div> */}
        </div>
      </div>
    );
  }
}

GlobalPresetsLocationContainer.propTypes = {
  departurePostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  selectedDeparturePostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  departureCheckedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  departureExpandedPostalOperators: PropTypes.arrayOf(PropTypes.string),
  departureCheckedUnlocodes: PropTypes.arrayOf(PropTypes.string),
  retrieveOutboundPostalOperatorsUnlocodeRequestActionCreator: PropTypes.func,
  departureUnlocodeCheckedActionCreator: PropTypes.func,
  onDeparturePostalOperatorExpandedUnlocodeAdmin: PropTypes.func,
  onSelectAllDepartureUnlocodes: PropTypes.func,
  onDeSelectAllDepartureUnlocodes: PropTypes.func,
  arrivalPostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  arrivalCheckedUnlocodes: PropTypes.arrayOf(PropTypes.string),
  arrivalExpandedPostalOperators: PropTypes.arrayOf(PropTypes.string),
  selectedArrivalPostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  arrivalUnlocodeCheckedActionCreator: PropTypes.func,
  onArrivalPostalOperatorExpanded: PropTypes.func,
  onSelectAllArrivalUnlocodes: PropTypes.func,
  onDeSelectAllArrivalUnlocodes: PropTypes.func,
  retrieveInboundPostalOperatorsUnlocodeRequestActionCreator: PropTypes.func,
  saveGlobalSelectionUnlocodeRequestActionCreator: PropTypes.func,
  departureSelections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    unlocodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  arrivalSelections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    unlocodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  setTabButtonStatus: PropTypes.func,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  retrieveOutboundPostalOperatorsUnlocodeRequestActionCreator,
  retrieveInboundPostalOperatorsUnlocodeRequestActionCreator,
  departureUnlocodeCheckedActionCreator,
  onDeparturePostalOperatorExpandedUnlocodeAdmin,
  onSelectAllDepartureUnlocodes,
  onDeSelectAllDepartureUnlocodes,
  arrivalUnlocodeCheckedActionCreator,
  onArrivalPostalOperatorExpanded,
  onSelectAllArrivalUnlocodes,
  onDeSelectAllArrivalUnlocodes,
  saveGlobalSelectionUnlocodeRequestActionCreator,
  setTabButtonStatus,
}, dispatch);

const mapStateToProps = state => ({
  selectedDeparturePostalOperatorsNodes: getSelectedDeparturePostalOperators(state),
  departurePostalOperatorsNodes: getDeparturePostalOperators(state),
  departureCheckedUnlocodes: getDepartureCheckedUnlocodes(state),
  departureExpandedPostalOperators: getExpandedDeparturePostalOperatorsUnlocodeAdmin(state),
  selectedArrivalPostalOperatorsNodes: getSelectedArrivalPostalOperators(state),
  arrivalPostalOperatorsNodes: getArrivalPostalOperators(state),
  arrivalCheckedUnlocodes: getArrivalCheckedUnlocodes(state),
  arrivalExpandedPostalOperators: getExpandedArrivalPostalOperators(state),
});

/* Needed for prop-types with cloneElement */
export const ConnectedGlobalPresetsLocationContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(GlobalPresetsLocationContainer);

export default (ConnectedGlobalPresetsLocationContainer);
